<template>
  <v-row class="pa-0 ma-0 color-black">
    <v-col cols="12" v-for="(item, allDataNum) in allData" :key="allDataNum"
    class="pa-0 ma-0">
      <template 
      v-if=" item.componentType === 'title' ||
      item.componentType === 'min-title' ||
      item.componentType === 'text' ||
      item.componentType === 'list' ||
      item.componentType === 'iframe' ||
      item.componentType === 'pdf' ||
      item.componentType === 'hr' ||
      item.componentType === 'nullData' ||
      item.componentType === 'big-nullData' ||
      item.componentType === 'img' ||
      item.componentType === 'sdgs' ||
      item.componentType === 'video'" >
        <textComponent
           class="px-1"
          :all-data="item"
          :title-style="titleStyle"
          :subhead-style="subheadStyle"
          :text-alignment="textAlignment"
        />
      </template>
      <template v-if="item.componentType === 'swapTextAndImg'">
        <v-row id="textBox-two" cols="12" class="ma-0 pa-0">
          <v-col cols="12" v-for="(item2, sTAINum) in item.data" :key="sTAINum" class="pa-0 pt-4 pt-md-8 mt-4 mt-md-8 mb-md-8">
            <!-- 根據 item.layout 來調整排列方式 -->
            <v-row class="mx-0 pa-0" :class="[sTAINum % 2 === 0 ? '':'flex-md-row-reverse',
            sTAINum.length-1 == sTAINum? 'mb-8':'mb-0']">
              <v-col cols="12" md="6" width="100%" class="pa-0 pa-md-3">
                <!-- 左{{item2}} -->
                <div v-for="(lD , lDataMum) in item2.leftData" :key="lDataMum">
                  <textComponent
                    :all-data="lD"
                    :title-style="`${titleStyle} pt-0`"
                    :subhead-style="`${subheadStyle} pt-0`"
                    :text-alignment="'left'"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center justify-center mx-0" >
                  <div class="textBox pa-0 mt-2">
                    <h3 class="te-h3-B mt-5 mt-md-0 mb-4 pa-0 text-justify" :class="`${subheadStyle}`">{{ t(item2.rightData.title) }}</h3>
                    <template>
                      <div v-for="(content, contentIndex) in item2.rightData.contents" :key="contentIndex">
                        <p class="te-p mb-2 color-te-B text-justify" >{{ t(content.text) }}</p>
                      </div>
                    </template>
                    <div class="more-txt w-100 d-flex justify-end align-center pa-0" v-if="item2.rightData.link">
                      
                      <a class="ma-2 color-btn font-B rounded-pill icon16"
                        @click="$router.push({
                        path: item2.rightData.link.link,
                        query: {
                          tag: item2.rightData.link.title,
                        },
                        })"
                        :href="`${item2.rightData.link.link}?tag=${item2.rightData.link.title}`"
                        :title="`更多${t(item2.rightData.link.title)}資訊`">
                        {{ t('more') }}
                        <i class="ml-2 fa-solid fa-angles-right"></i>
                      </a>
                    </div>
                  </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>


      <template v-if="item.componentType === 'twoObjects'">
        <v-row id="textBox-two" cols="12" class="ma-0 pa-0 w-100">
          <v-col cols="12" class="pa-0 pt-4 pt-md-0  mt-4 mt-md-0">
            <v-row class="mb-8 mx-0 pa-0">
              <v-col cols="12" md="6" width="100%" class="pa-0 pa-md-3">
                <div v-for="(lD , lDataMum) in item.leftData" :key="lDataMum">
                  <textComponent
                    :all-data="lD"
                    :title-style="`${titleStyle} pt-0`"
                    :subhead-style="`${subheadStyle} pt-0`"
                    :text-alignment="'left'"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6" width="100%" class="pa-0 pa-md-3">
                <div v-for="(rD , rDataMum) in item.rightData" :key="rDataMum">
                  <textComponent
                    :all-data="rD"
                    :title-style="`${titleStyle} pt-0`"
                    :subhead-style="`${subheadStyle} pt-0`"
                    :text-alignment="'left'"
                  />
                </div>
              </v-col>
             
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-col>
    
  </v-row>
</template>

<script>
import textComponent from '../components/textComponent.vue'; // 导入文本组件


export default {
  props: [
    "allData",
    "titleStyle",
    "subheadStyle",
    "textAlignment",
  ],
  components: {
    textComponent,
  },
  methods: {
    getImg(imgName) {
      if (imgName.includes("https")) {
        return imgName;
      } else {
        // 使用完整路径下载文件
        return `/tools/img/${imgName}`;
      }
    },
  },
};
</script>


<style lang="scss">
.myP{
  width: fit-content;
}

.bannerSubtitle::after {
  content: "\00A0"; /* 使用 Unicode 表示半角空格 */
}
</style>